module.exports = __webpack_public_path__ + "static/media/ubc.c97012cd.jpg";